export const addressedAtOptions = [
  {
    value: "She/her/hers",
    label: "She/her/hers"
  },
  {
    value: "He/him/his",
    label: "He/him/his"
  },
  {
    value: "They/them/theirs",
    label: "They/them/theirs"
  },
  {
    value: "Ze/hir/hirs",
    label: "Ze/Hir/Hirs"
  },
  {
    value: "No pronoun",
    label: "No Pronoun"
  },
  {
    value: "No preference",
    label: "No preference"
  },
  {
    value: "Not listed",
    label: "Not listed"
  },
  {
    value: "I prefer not to say",
    label: "I prefer not to say"
  }
];

export const thinkYourself = [
  {
    value: "Straight or heterosexual",
    label: "Straight or heterosexual"
  },
  {
    value: "Lesbian, gay or homosexual",
    label: "Lesbian, gay or homosexual"
  },
  {
    value: "Bisexual",
    label: "Bisexual"
  },
  {
    value: "Pansexual",
    label: "Pansexual"
  },
  {
    value: "Don't know",
    label: "Don't know"
  },
  {
    value: "Choose not to disclose",
    label: "Choose not to disclose"
  }
];

export const identity = [
  {
    value: "Male",
    label: "Male"
  },
  {
    value: "Female",
    label: "Female"
  },
  {
    value: "Transgender male/Trans man/Female-to-Male (FTM)",
    label: "Transgender male/Trans man/Female-to-Male (FTM)"
  },
  {
    value: "Transgender Female/Trans woman/Male-to-Female (MTF)",
    label: "Transgender Female/Trans woman/Male-to-Female (MTF)"
  },
  {
    value: "Genderqueer, neither exclusively male nor female",
    label: "Genderqueer, neither exclusively male nor female"
  },
  {
    value: "Choose not to disclose",
    label: "Choose not to disclose"
  }
];

export const sexOptions = [
  {
    value: "male",
    label: "Assigned male at birth"
  },
  {
    value: "female",
    label: "Assigned female at birth"
  },
  {
    value: "intersex",
    label: "Intersex (born with sexual anatomy, reproductive organs, and/or chromosome)"
  }
];

export const ethnicityOptions = [
  {
    value: "hispani",
    label: "Yes"
  },
  {
    value: "not-hispani",
    label: "No"
  },
  {
    value: "unknown",
    label: "Decline to State"
  }
];

export const raceOptions = [
  {
    label: "American Indian or Alaska Native",
    value: "alaska"
  },
  { label: "Asian", value: "asian" },
  {
    label: "Native Hawaiian or Other Pacific Islander",
    value: "Hawaiian"
  },
  {
    label: "Black or African-American",
    value: "africa"
  },
  { label: "White", value: "white" },
  { label: "Other", value: "other" },
  {
    label: "Decline to State",
    value: "unknown"
  }
];

export const memberPassOptions = [
  {
    label: "Yes",
    value: true
  },
  {
    label: "No",
    value: false
  }
];

export const availableStates = [
  { label: "Alaska", value: "AK" },
  { label: "Alabama", value: "AL" },
  { label: "Arkansas", value: "AR" },
  { label: "Arizona", value: "AZ" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Iowa", value: "IA" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Massachusetts", value: "MA" },
  { label: "Maryland", value: "MD" },
  { label: "Maine", value: "ME" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Missouri", value: "MO" },
  { label: "Mississippi", value: "MS" },
  { label: "Montana", value: "MT" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Nebraska", value: "NE" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "Nevada", value: "NV" },
  { label: "New York", value: "NY" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Virginia", value: "VA" },
  { label: "Vermont", value: "VT" },
  { label: "Washington", value: "WA" },
  { label: "Wisconsin", value: "WI" },
  { label: "West Virginia", value: "WV" },
  { label: "Wyoming", value: "WY" }
];
